export interface CaptchaStoreState {
  isCaptchaVisible: boolean;
  captchaToken?: string;
}

export const initCaptchaStoreState: CaptchaStoreState = {
  isCaptchaVisible: false,
};
